import { AwsUi } from '../../../core/runtime/src';
import createKeysMap from './keysMap';
import { Flash } from './flash';
// A flash bar generates a list of flash messages (see awsui-flash component) based on an
// object representation of the component.
export var Flashbar = AwsUi.__addComponent('awsui-flashbar', {
    releaseStatus: 'stable',
    properties: {
        //  Flash messages will appear in the same order that they are listed.
        // `Items` is an array of flash message definition objects.
        //
        // Each flash message object has the following properties available:
        // * `header` [Renderable]: Heading text.
        // * `content` [Renderable]: Primary text displayed in the element.
        // * `type` [string]: Indicates the type of the message to be displayed. Allowed values: *success, error, warning, info* (default: "*info*").
        // * `loading` [boolean]: Replaces the status icon with a spinner and forces the type of alert to info.
        // * `dismissible` [boolean]: If true, the component will include a close button icon in the UI. By default, the close button is not included in the UI.
        // Clicking on this icon will fire the `awsui:dismiss` event.
        // * `dismissLabel` [string]: Adds an aria-label to the dismiss icon button for improved accessibility.
        // * `buttonText` [string]: When set, a normal action button is displayed with the specified text. Clicking on this button will fire the `awsui:buttonClick` event.
        //
        // Each flash message object also has the following events available:
        // * `dismiss` [event => null]: The event fired when a user clicks on the close icon that is displayed when the dismissible property is set to true.
        // * `buttonClick` [event => null]: The event fired when a user clicks on the action button.
        //
        // **AngularJS:**
        // Internally, the `dismiss` and `buttonClick` functions do not invoke a digest loop.
        // Therefore, it is your responsibility to manually call `$scope.$apply` if you need to.
        items: {
            type: 'array',
            itemTypes: ['Flashbar.MessageDefinition'],
            onChange: function () {
                this.keysMap.updateKeys(this.items);
            }
        }
    },
    callbacks: {
        initialized: function () {
            this.keysMap = createKeysMap();
        }
    },
    render: function (m, h) {
        var _this = this;
        var hasItems = Boolean(this.items) && this.items.length > 0;
        if (!hasItems) {
            return;
        }
        var items = this.items.map(function (item, index) {
            var content = item.content ? _this.renderToMithril("flash-content-" + index, item.content) : '';
            var header = item.header ? _this.renderToMithril("flash-header-" + index, item.header) : '';
            var dismissible = item.dismissible === undefined ? null : item.dismissible;
            return (AwsUi.__createElement(Flash, { key: _this.keysMap.getKey(item), dismissible: dismissible, loading: Boolean(item.loading), type: item.type || 'info', content: content, header: header, buttonText: item.buttonText, buttonClick: item.buttonClick, dismiss: item.dismiss, dismissLabel: item.dismissLabel }));
        });
        return AwsUi.__createElement("div", { className: "awsui-flashbar" }, items);
    }
});
//# sourceMappingURL=flashbar.js.map